import Cookies from 'js-cookie';
var state = {
  rangeObj: {},
  // 绑定收费标准范围
  chargeList: [],
  // 批量添加收费标准
  checkedNodes: [],
  // 选中的树节点
  menuId: '',
  // 菜单id
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  isShowSidebar: true,
  device: 'desktop'
};
var mutations = {
  SET_RANGEOBJ: function SET_RANGEOBJ(state, rangeObj) {
    state.rangeObj = rangeObj;
  },
  SET_CHARGELIST: function SET_CHARGELIST(state, chargeList) {
    state.chargeList = chargeList;
  },
  SET_CHECKEDNODES: function SET_CHECKEDNODES(state, checkedNodes) {
    state.checkedNodes = checkedNodes;
  },
  SET_MENUID: function SET_MENUID(state, menuId) {
    state.menuId = menuId;
  },
  CHANGE_SIDEBAR: function CHANGE_SIDEBAR(state, isShow) {
    state.isShowSidebar = isShow;
  },
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;

    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  }
};
var actions = {
  setRangeObj: function setRangeObj(_ref, rangeObj) {
    var commit = _ref.commit;
    commit('SET_RANGEOBJ', rangeObj);
  },
  setChargeList: function setChargeList(_ref2, chargeList) {
    var commit = _ref2.commit;
    commit('SET_CHARGELIST', chargeList);
  },
  setCheckedNodes: function setCheckedNodes(_ref3, checkedNodes) {
    var commit = _ref3.commit;
    commit('SET_CHECKEDNODES', checkedNodes);
  },
  toggleSideBar: function toggleSideBar(_ref4) {
    var commit = _ref4.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref5, _ref6) {
    var commit = _ref5.commit;
    var withoutAnimation = _ref6.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref7, device) {
    var commit = _ref7.commit;
    commit('TOGGLE_DEVICE', device);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};